import {AbstractAnimation} from './AbstractAnimation';
import {BaseAnimation} from './BaseAnimation';

export class GroupAnimation extends AbstractAnimation {

    private animations:AbstractAnimation[];
    private finished:number=0;

    constructor(...animations:AbstractAnimation[]) {
        super();
        this.animations=animations;
    }

    protected getHandler(target:object,prop:string|symbol,receiver:any) {
        if (Reflect.has(target,prop)) return Reflect.get(target,prop,receiver);
        var found:any[]=[];
        for (var anim of this.animations) {
            var engine=anim.engine();
            if (!engine) continue;
            for (var obj of [anim,engine]) {
                if (Reflect.has(obj,prop)) {
                    var fnc=Reflect.get(obj,prop);
                    if (typeof fnc=='function') fnc=fnc.bind(obj);
                    found.push(fnc);
                    break;
                }
            }
        }
        return (...args:any[])=>{
            var r:any[]=[];
            for (var f of found) f(...args);
            return r;
        };
    }

    protected hasHandler(target:object,prop:string|symbol) {
        if (Reflect.has(target,prop)) return true;
        var found=[];
        for (var anim of this.animations) {
            var engine=anim.engine();
            if (!engine) continue;
            for (var obj of [anim,engine]) {
                if (Reflect.has(obj,prop)) return true;
            }
        }
        return false;
    }

    public add(...animations:AbstractAnimation[]) {
        this.animations.push(...animations);
    }

    public reverse(direction:boolean|null) {
        for (var anim of this.animations) {
            if (anim instanceof BaseAnimation) anim.reverse(direction);
        }
        return this;
    }

    private finish=()=>{
        this.finished++;
        if (this.finished==this.animations.length) {
            this.trigger('end');
        }
    }

    public applyFrom():this {
        for (var anim of this.animations) {
            anim.applyFrom();
        }

        return this;
    }

    public promise(event:string) {
        let promises=[];
        for (var anim of this.animations) {
            promises.push(anim.promise(event));
        }
        return Promise.all(promises);
    }

    public async playSequentially() {
        for (var ani of this.animations) {
            await ani.play();
        }
        this.finish();
    }

    public play() {
        this.finished=0;
        this.trigger('begin');
        for (var ani of this.animations) {
            ani.play().on('end',this.finish);
        }
        //Cast to any to prevent TypeScript from complaining when used with await
        return <any>this;
    }

}

export {};